module.exports = __webpack_public_path__ + "assets/algolia.a136a9cc.svg";